// extracted by mini-css-extract-plugin
export default {"wrapper":"Eo-z","response":"Fo-z","error":"Go-z","disabled":"Ho-z","buttons":"Io-z","feedbackQuestionSection":"Jo-z","yesNoWrapper":"Ko-z"};